<template>
    <modal :modal-id="modalId" :title="modalTitle" :preloader="preloader" @submit="submit" @close-modal="closeModal">
        <template slot="body">
            <div class="card-body">
                <form ref="form" :data-url="!!selectedUrl && dataContact?.id ? `contacts/${dataContact.id}` : `contacts`" class="mb-0"
                    :class="{ 'loading-opacity': preloader }">
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0 required">
                            {{ $t('contact_name') }}
                        </label>
                        <app-input class="col-md-8" type="text" v-model="dataContact.name" :required="true"
                            :placeholder="$t('Contact_name')" />
                    </div>

                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0 required">
                            {{ $t('phone') }}
                        </label>
                        <app-input class="col-md-8" type="tel-input" v-model="dataContact.Phone" :required="true"
                            min="6" :placeholder="$t('phone')" />
                    </div>

                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('fax') }}
                        </label>
                        <app-input class="col-md-8" type="number" v-model="dataContact.Fax" min="6"
                            :placeholder="$t('fax')" />
                    </div>

                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0 required">
                            {{ $t('email') }}
                        </label>
                        <app-input class="col-md-8" type="email" v-model="dataContact.Email" :required="true" min="6"
                            :placeholder="$t('email')" />
                    </div>

                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0 required">
                            {{ $t('position') }}
                        </label>
                        <app-input class="col-md-8" type="text" v-model="dataContact.Position" :required="true" min="6"
                            :placeholder="$t('position')" />
                    </div>
                </form>
            </div>
        </template>
    </modal>
</template>

<script>
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';
import {validateInputs } from "../../../../../utils"

export default {
    name: "comapniesContactsForm",
    mixins: [FormMixin, ModalMixin],

    props: {
        dataContact: {
            type: Object,
            required: false, // Corregir el typo aquí,
            default: {}
        },

        selectedUrl: {
            type: String,
            required: true // Corregir el typo aquí
        },

        company_id: {
            type: Number,
            required: true,
        }

    },
    data() {
        return {
            preloader: false,
            modalId: 'comapanies-contacts-modal',
            modalTitle: this.$t('edit'),
        }
    },
    methods: {
        validations(){
            const validations = {
                name: { required: true,  message: 'the contact name is required.' },
                Phone: { required: true, message: 'Phone number is required.' },
                Email: { required: true,message: 'Email cannot exceed 50 characters.' },
                Position: { required: true, message: 'Position is required' },
            };
            if (!validateInputs(this, this.dataContact, validations)) {
                return;
            }
            return true
        },

        submit() {
            if (!this.validations()) {
                return;
            }
            if (this.company_id != 0) {
                this.dataContact.company_id = this.company_id
            } 
            this.save(this.dataContact)
        },

        beforeSubmit() {
            this.preloader = true;
        },

        afterSuccess(response) {
            this.$toastr.s(response.data.data.message); // Muestra el mensaje de éxito
            this.updateContactInLocalStorage(response.data.data.contact)
            this.closeModal()
        },

        updateContactInLocalStorage(updatedAddress) {
            let storedAddresses = JSON.parse(localStorage.getItem('DataContactsEdit')) || [];
            const existingIndex = storedAddresses.findIndex(address => address.id === updatedAddress.id);
            if (existingIndex !== -1) {
                storedAddresses[existingIndex] = updatedAddress;
            } else {
                storedAddresses.push(updatedAddress);
            }
            localStorage.setItem('DataContactsEdit', JSON.stringify(storedAddresses));
            this.$emit('contact-updated', updatedAddress);
        },

        closeModal() {
            this.hideModal();
            this.$emit('close-modal-contacts');
            this.preloader = false
        },

        beforeSubmit() {
            this.preloader = true;
        },

        afterFinalResponse() {
            this.preloader = false;
            this.inputs = {
                gender: 'male',
            };
        },

        afterError(res) {
            this.$toastr.e(res.data.message);
        },

        clear() {
            this.inputs = {
                gender: 'male',
            };
            this.fieldStatus = {
                isSubmit: false
            }
        },

        hideModal() {
            $('#' + this.modalId).modal('hide');
        },
    },

    mounted(){
        console.log("dataContact:", this.dataContact);
        console.log("selectedUrl:", this.selectedUrl);
        console.log("company_id:", this.company_id);
    }
}
</script>
